export default "__VITE_ASSET__DEulSZx9__"